import React, { useEffect, useRef, useState, Dispatch, SetStateAction } from 'react';
import styles from '@stylesheet';
import { ScrollView, Image, TouchableOpacity, ImageBackground, Platform, TextInput, Touchable, Switch, Text, View } from 'react-native';
import { Pressable } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { Title } from '@constants/Themed';
import { MaterialIcons } from '@expo/vector-icons'
import * as ImagePicker from 'expo-image-picker';
import apis from '@api/api';
import { AVATAR_UPDATED, DOWNLOAD_AVATAR, GOOGLE_LOGOUT, LOGGED_OUT, LOGO_UPDATED, SHOW_AUTH_MODAL } from '@reduxLocal/actions/types';
import { DefaultRootState } from '@reduxLocal/persistState';
import { manipulateAsync, SaveFormat } from 'expo-image-manipulator';
import PercentageBar from '@components/Global/PercentageBar';
import toTitleCase from '@hooks/toTitleCase';
import CompanyAchievementList from '@components/cards/companyAchievementList';
import { BarChart } from 'react-native-chart-kit';

const ProfileScreen = ({ navigation }) => {
  const dispatch = useDispatch();
  let [avatarUpload, setAvatarUpload] = useState({ img: '', smallImg: '' });
  let [res, setRes] = useState(null);
  const [tint, setTint] = useState(false);
  let achievementPoints: number = 6794;
  

  const chartConfig = {
    backgroundColor: "transparent",
    backgroundGradientFrom: "transparent",
    backgroundGradientTo: "transparent",
    fillShadowColor: '#FF493B', // THIS
    fillShadowColorOpacity: 1,
    borderRadius: 20,
    decimalPlaces: 2, // optional, defaults to 2dp
    color: (opacity = 1) => `rgba(255, 255, 255, ${opacity})`,
    labelColor: (opacity = 1) => `rgba(255, 255, 255, ${opacity})`,
    style: {
      borderRadius: 16
    },
  }

  const data = {
    labels: ["January", "February", "March", "April", "May", "June"],
    datasets: [
      {
        data: [20, 45, 28, 80, 99, 43]
      }
    ]
  };

  const user = useSelector((state: DefaultRootState) => state.promiseData.data.userData);
  const company = useSelector((state: DefaultRootState) => state.promiseData.data.companyData);
  let companyName  = company?.companyName;
  let companyNumber = company?.companyNumber?.toString();
  let avatar = user.avatar.img;
  let logo = company?.companyLogo?.img;

  useEffect(() => {
    (async () => {
      if (Platform.OS != 'web') {
        const { status } = await ImagePicker.requestMediaLibraryPermissionsAsync();
        if (status != 'granted') {
          alert('Camera roll permissions required');
        }
      }
    })();
    return () => {
      setAvatarUpload({ img: '', smallImg: '' });
    }
  }, []);

  const _resizeImage = async () => {
    const pickImage = async () => {
      let result: ImagePicker.ImagePickerResult;
      const permissionResult = await ImagePicker.requestMediaLibraryPermissionsAsync();

      if (permissionResult.granted === false) {
        alert("You've refused to allow this app to access your photos!");
        return;
      }

      result = await ImagePicker.launchImageLibraryAsync({
        mediaTypes: ImagePicker.MediaTypeOptions.All,
        allowsEditing: true,
        base64: true,
      });

      if (!result.canceled) {
        return result;
        // dispatch({ type: AVATAR_UPDATED, data: avatarUpload.img }) }
      }
      if (result.canceled) {
        alert("Upload canceled");
        return;
      }
      return result;
    };
    pickImage().then(async result => {
      const { uri } = result;
      const manipResultImg = await manipulateAsync(uri, [
        {
          resize: { height: 200 }
        }
      ], { format: SaveFormat.PNG }
      );
      const manipResultImgSmall = await manipulateAsync(uri, [
        {
          resize: { height: 60 }
        }
      ], { format: SaveFormat.PNG })
      let img = manipResultImg.base64;
      let smallImg = manipResultImgSmall.base64;
      apis.postLogo(company.companyID, { img, smallImg })
        .then(res => {
          if (res.status !== 200) {
            dispatch({ type: SHOW_AUTH_MODAL, data: 'Could not upload Avatar' });
          }
          if (res?.status == 200) {
            let prepend = 'data:image/png;base64,';
            dispatch({ type: LOGO_UPDATED, data: prepend + img })
          }
        })
        .catch(err => {
          let errStatus = err.response.status?.toString();
          if (errStatus == 413) {
            dispatch({ type: SHOW_AUTH_MODAL, data: 'Failed to upload Company Logo, file size too large!' })
          } else { console.log(errStatus) }
        }
        )
    });
  }


  //TODO #18 add details change functionality 
  const CompanyInfo = () => {
    return (
      <View style={{ flex: 1, flexDirection:  'column', flexWrap: 'wrap', padding: 40, paddingRight: 250, borderRadius: 20 }}>
        <View style={{ flex: 1.5, alignItems: 'flex-start', flexDirection: 'row' }}>
          <TouchableOpacity onPress={_resizeImage} style={{ marginLeft: 25, zIndex: 2 }}>
            <View style={{ flexDirection: 'row', justifyContent: 'center', alignContent: 'center' }}>
              <Pressable onPress={_resizeImage} onHoverIn={() => { setTint(true) }} onHoverOut={() => { setTint(false) }} >
                <Image style={[styles.customerLogo, { tintColor: tint ? 'grey' : '', width: 320 }]} source={logo} />
              </Pressable>
            </View>
            <View style={{ flexDirection: 'column', flex: 1.5, alignItems: 'center' }}>
              <Title>{toTitleCase(companyName)}</Title>
              <Title>{toTitleCase(companyNumber)}</Title>
            </View>
          </TouchableOpacity>
          <View style={{ padding: 25, flexWrap: 'wrap', flex: 5 }}>
            <View style={{ maxWidth: 400, marginVertical: 10 }}>
            </View>
          </View>
        </View>
      </View >
    )
  }

  return (
    <View style={styles.pageContainer}>
      <ScrollView style={[styles.pageContainer, { padding: 40 }]}>
        <View style={{ flexDirection: 'row', flex: 1, flexWrap: 'wrap', alignContent: 'stretch' }}>
          <View style={[styles.noteContainer, { flex: 1, borderRadius: 20, flexDirection: 'column' }]}>
            <View style={{ flex: 1 }}>
              <CompanyAchievementList achievementData={null} achievementPoints={achievementPoints} navigation={navigation} />
            </View>
            <View style={{ flex: 0.1, minHeight: 20 }} />
            <View style={{ flex: 1 }}>
              <BarChart
                style={[styles.chartContainer, { backgroundColor: 'rgba(90,192,234,1)', padding: 0, borderRadius: 20 }]}
                data={data}
                width={600}
                height={220}
                yAxisLabel="$"
                chartConfig={chartConfig}
                showValuesOnTopOfBars={true}
                verticalLabelRotation={30}
              />
            </View>
          </View>
          <View style={{ flex: 0.1 }} />
          <View style={[styles.noteContainer, { flex: 1, borderRadius: 20, flexDirection: 'row' }]}>
            <CompanyInfo />
            <View style={{ flex: 2, padding: 20 }}>
              <PercentageBar title={'Users'} percentage={'10%'} backgroundColor={'#1E90FF'} completedColor={'red'} height={20} />
              <PercentageBar title={'Storage'} percentage={'50%'} backgroundColor={'#1E90FF'} completedColor={'red'} height={20} />
            </View>
          </View>
        </View>
      </ScrollView>
    </View>
  );
}

export default ProfileScreen;